export default class VisitPoint {
	constructor({
		id,
		identification,
		cy,
		cx,
		city,
		department,
		country,
		address,
		time_service,
		priority,
		additional_info,
		json_properties,
		status_id,
		skills_id,
		capacities,
		time_window_id,
	}) {
		this.id = this._getValueOrDefault(id, 0);
		this.identification = this._getValueOrDefault(identification, "");
		this.cy = this._getValueOrDefault(cy, 0);
		this.cx = this._getValueOrDefault(cx, 0);
		this.city = this._getValueOrDefault(city, "");
		this.department = this._getValueOrDefault(department, "");
		this.country = this._getValueOrDefault(country, "");
		this.address = this._getValueOrDefault(address, "");
		this.time_service = this._getValueOrDefault(time_service, "");
		this.priority = this._getValueOrDefault(priority, 0);
		this.additional_info = this._getValueOrDefault(additional_info, {});
		this.json_properties = this._getValueOrDefault(json_properties, []);
		this.status_id = this._getValueOrDefault(status_id, 0);
		this.skills_id = this._getValueOrDefault(skills_id, []);
		this.capacities = this._getValueOrDefault(capacities, []);
		this.time_window_id = this._getValueOrDefault(time_window_id, []);
	}
	_getValueOrDefault(value, defaultValue) {
		return value === undefined || value === null ? defaultValue : value;
	}
}
